export default __webpack_public_path__ + "static/media/vectorHeartActive.553ab50a.svg";